(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDeleteController',ChatMessageDeleteController);

    ChatMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChatMessage'];

    function ChatMessageDeleteController($uibModalInstance, entity, ChatMessage) {
        var vm = this;

        vm.chatMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ChatMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(id);
                });
        }
    }
})();
